import React from 'react'

// A short label that opens a sentence, e.g. "Strong fit:" or "Reference account:".
const LEADING_LABEL = /(^|[.;!?]\s+)([A-Z][\w'’/&-]*(?:\s[\w'’/&-]+){0,3}):(?=\s)/g

/** Text whose sentence-opening labels ("Strong fit:") are rendered bold and darker. */
export default function LabeledText({ text, className }: { text: string; className?: string }) {
    const parts: React.ReactNode[] = []
    let cursor = 0
    String(text || '').replace(LEADING_LABEL, (match, lead: string, label: string, offset: number) => {
        const labelStart = offset + lead.length
        parts.push(text.slice(cursor, labelStart))
        parts.push(
            <strong key={labelStart} className='font-semibold text-gray-900 dark:text-gray-100'>
                {label}:
            </strong>,
        )
        cursor = labelStart + label.length + 1
        return match
    })
    parts.push(text.slice(cursor))
    return <p className={className}>{parts}</p>
}
